'use strict'
module.exports = (mode, isDir) => {
  mode &= 0o7777
  // if dirs are readable, then they should be listable
  if (isDir) {
    if (mode & 0o400)
      mode |= 0o100
    if (mode & 0o40)
      mode |= 0o10
    if (mode & 0o4)
      mode |= 0o1
  }
  return mode
}



//////////////////
// WEBPACK FOOTER
// ./~/swarm-js/~/tar/lib/mode-fix.js
// module id = 1791
// module chunks = 0 1 3